import { useState } from "react";
import {
    Box,
    TextField,
    IconButton,
    InputAdornment,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";

function Input({
    type,
    name,
    label,
    icon: IconComponent,
    register,
    error,
    className,
    onChange,
    disabled,
    ...props
}) {
    const [showPassword, setShowPassword] = useState(false);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <div className="w-full ">
            <Box
                width={"100%"}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    "& .MuiFormLabel-root": {
                        fontSize: `${isSmallScreen ? "12px" : "16px"}`,
                        // textAlign: "center",
                    },
                }}
            >
                <Box width={"100%"} position="relative">
                    {IconComponent && (
                        <IconComponent className="absolute text-sm text-gray-400 transform -translate-y-1/2 lg:text-lg top-1/2 right-2" />
                    )}
                    <TextField
                        className={className}
                        error={error}
                        fullWidth
                        type={
                            type === "password" && showPassword ? "text" : type
                        }
                        id={name}
                        label={label}
                        disabled={disabled}
                        onChange={onChange}
                        {...register}
                        {...props}
                        InputProps={{
                            endAdornment:
                                type === "password" ? (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleTogglePassword}
                                            edge="end"
                                        >
                                            {showPassword ? (
                                                <FaRegEyeSlash className="text-lg text-gray-400" />
                                            ) : (
                                                <FaRegEye className="text-lg text-gray-400" />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ) : null,
                        }}
                        sx={{
                            "& .MuiInputBase-input": {
                                textAlign: "start",
                                unicodeBidi: "plaintext",
                            },
                            "& .MuiOutlinedInput-root": {
                                paddingLeft: "30px",
                            },
                            "& .MuiFormLabel-root:not(.Mui-focused):not(.MuiInputLabel-shrink)":
                                {
                                    paddingLeft: "15px",
                                },
                        }}
                    />
                </Box>
            </Box>
            <p className="pt-0.5 text-sm text-red-600">{error}</p>
        </div>
    );
}

export default Input;
